/**
 * 장비불러 모바일 부팅 — 모바일 전 페이지 진입 시 1회 실행 (app.js $(document).ready → loadSiteBootstrap).
 * 구 mobile.js 의 initMobile() 을 여기로 흡수했다(전역 함수 제거). 실행 순서는 그대로 보존한다.
 */

// 로그인당 1회 전체팝업(공지/약관개정) 판정용 — 이 로그인에서 팝업을 띄운 loginKey (sessionStorage).
const POPUP_KEY = 'app:popup:started';

export default {
    initialize: function () {
        // 회원가입 앱바 뒤로 (signup/partials/bar) — data-confirm 이면 입력 내용을 잃는다는 확인부터
        $(document).on('click', '#sg-back', async function () {
            if (this.dataset.confirm) {
                const ok = await $j.Ui.Dialog.confirm('회원가입을 그만두시겠어요?', {
                    tone:    'warn',
                    desc:    '지금까지 입력한 내용은 저장되지 않습니다.',
                    confirm: '나가기',
                    cancel:  '계속 작성',
                });
                if (!ok) return;
            }
            location.replace(this.dataset.href);
        });

        // ── 1. 화면·레이아웃 크롬 ─────────────────────────────
        // 모비스크롤 테마: light/dark 는 여기서 박지 않는다 — Theme.syncMobiscroll 이 화면모드로 정한다.
        // (이 부팅이 main.js 의 Theme 생성자보다 나중에 돌아, 여기서 light 를 박으면 dark 를 매번 되돌린다.)
        mobiscroll.setOptions({ theme: 'material' });
        $j.F.Mobile.Theme.syncMobiscroll();
        $j.Common.Util.registerVibrateButton();    // 버튼 누르면 진동
        $j.Ui.PullRefresh.enable();                // 당겨서 새로고침
        // 바텀시트 — 끌어내리다 손 떼면 그 자리에 멈춘다(2026-10 홍과장님 요청).
        // looseDrag 는 켜지 않는다 — 시트 안 입력 폼이 많아 닫기 판정을 완화하면 입력 유실 위험(종전 유지).
        // header:'slot' + dragBar — 제목 왼쪽·부제·진행 막대를 담는 헤더에 손잡이를 켠다. 닫기 X 는 그대로 남긴다
        // (끌기는 지름길, X 가 주 경로 — 리뉴얼 스킬 2-9장).
        $j.Ui.BS.init({ stopAnywhere: true, header: 'slot', dragBar: true });

        // ── 2. 인프라 ────────────────────────────────────────
        $j.Common.Network.start();                 // 오프라인/느린망 감시
        $j.F.JbApp.start();                        // 앱 통신 초기화(디바이스 컨텍스트·현재페이지 통보·헬스체크) — /ma 도 같은 흐름을 부른다

        // ── 여기까지 전 페이지 공통. 아래는 로그인 회원 한정 — 비로그인은 종료 ──
        if (!(typeof MEMBER !== 'undefined' && MEMBER && MEMBER.num > 0)) return;

        // ── 3. 로그인 회원 (매 페이지) ───────────────────────
        $j.F.Mobile.ProxyBar.start();              // /ma 대리진입 중이면 '관리자 복귀' 알약 (아니면 no-op)
        $j.F.Mobile.SiteSwitch.start();            // CS 면 '관리자'(/ma) 전환 알약 (아니면 no-op — 둘은 동시에 뜨지 않는다)
        $j.F.Mobile.Layout.showOldTopNav();        // 상단 메뉴
        $j.F.Mobile.Layout.bindHeaderTap();        // 헤더 탭
        $j.F.Mobile.Layout.markMenuVisit();        // 최근·자주 찾는 메뉴 기록 (도착한 화면 기준)
        $j.F.Postcode.init({ backClose: true, backBar: true }); // 주소 검색 레이어 — 다른 하위화면처럼 왼쪽 ‹ 뒤로 + 가운데 제목, 폰 뒤로가기로 레이어만 닫기
        $j.F.Mobile.Theme.migrateLegacyZoom();     // 레거시 줌쿠키 → 3단계 1회 이전
        $j.F.Mobile.Layout.showMemberStatusBanner(); // 회원상태(탈퇴신청 배너)

        // ── 4. 로그인 직후 묶음 ──────────────────────────────
        // "로그인 후 첫 화면에서 할 것들". 매 페이지 돌지만 각 항목이 loginKey/세션/스탬프로 자체
        // 게이팅해 실제로는 로그인당(또는 필요시) 1회만 동작한다. 어느 화면으로 진입하든 걸린다.
        this._afterLogin();
    },


    /** 로그인 직후 묶음 — 각 항목 자체 게이팅(비로그인은 내부에서 skip). */
    _afterLogin: function () {
        $j.F.App.clearHistoryOnFreshLogin();   // 웹뷰 history 초기화 (첫 화면 백버튼 → 로그인 방지)
        $j.F.JbApp.syncMySettingsOncePerLogin();   // 회원 환경설정(푸시·TTS·알림음) → 네이티브 동기화
        // 앱 업데이트 게이트를 위치동의보다 **먼저** 부른다 — 지원하지 않는 구앱이면 GPS 권한을
        // 받아봐야 소용이 없고, 동의 시트 위에 강제 화면이 겹쳐 뜨는 것도 막는다.
        // 서버 조회는 로그인당 1회고(그 뒤 세션 캐시), 강제 판정만 매 페이지 다시 그린다.
        $j.F.AppGate.start();                      // 앱버전 게이트 (지원하한 미만=강제 / 최신 미만=안내)
        $j.F.Mobile.LocationGate.start();          // 수발주자 위치 약관동의 BS + GPS 권한 토스트
        this._startPopupPreviewIfRequested();      // 관리자 팝업 미리보기(?popupPreview=) — 회원 자동팝업보다 먼저(억제 플래그 선점)
        this._startPopupOncePerLogin();            // 공지/약관개정 전체팝업
    },

    /**
     * 관리자 팝업 미리보기 — 실제 앱 화면 위에 특정 공지 팝업을 강제로 띄운다.
     * 관리자가 /adm/board 미리보기에서 대리로그인(+?popupPreview={공지id})으로 들어온 경우에만 동작한다.
     * 대리로그인 중 자동팝업은 억제되지만(listForMember), 여기서 쓰는 preview() 는 그 억제를 거치지 않는다.
     * __POPUP_PREVIEW__ 를 **동기로** 세워, 아래 _startPopupOncePerLogin 이 회원 자동팝업을 띄우지 않게 한다.
     */
    _startPopupPreviewIfRequested: function () {
        if (!(typeof G5 !== 'undefined' && G5.isAdmin)) return;
        const id = new URLSearchParams(location.search).get('popupPreview');
        if (!id) return;
        window.__POPUP_PREVIEW__ = true;           // 회원 자동팝업 억제 (_startPopupOncePerLogin)
        $.get('/m/ajax/popup/preview-item', { num: id }, (res) => {
            if (res && res.result && res.item) $j.F.Popup.preview(res.item);
        });
    },

    /**
     * 공지/약관개정 전체팝업 — 로그인당 1회. 어느 화면으로 진입하든 첫 화면에서 한 번만 띄우고,
     * 이후 페이지 이동에는 다시 뜨지 않는다. ('다시 보지 않기'는 로그인을 넘어 서버가 기억)
     * loginKey 없으면(구앱 세션) 회원번호로 폴백 — 최소한 탭 세션 1회로는 묶인다.
     */
    _startPopupOncePerLogin: function () {
        // 관리자 팝업 미리보기 페이지 — 미리보는 글만 띄우므로 회원 대상 자동팝업은 끈다.
        // 미리보기 화면(notice/preview 의 #previewStage[data-popup-preview])도 같다
        if (window.__POPUP_PREVIEW__ || document.querySelector('[data-popup-preview]')) return;
        const lk = String((typeof MEMBER !== 'undefined' && MEMBER && (MEMBER.loginKey || MEMBER.num)) || '');
        if ($j.Common.Store.session.get(POPUP_KEY) === lk) return;
        $j.Common.Store.session.set(POPUP_KEY, lk);
        $j.F.Popup.start();
    }
};
